//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入公共组件
import Headers from '@/components/common/Headers.vue'
import help from '@/components/common/help.vue'
import {mapState, mapActions, mapGetters} from 'vuex';

export default {
  components: {
    Headers, help
  },
  computed: {
    ...mapState({
      dropwindow: state => state.status.showDropWindow,
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    ...mapActions({
      showdropwindow: 'showDropWindow',
      setClickExerBasketFlag: 'setClickExerBasketFlag',
      setHeaderThree: 'setHeaderThree'
    }),
    clickExerBasket() {
      this.setClickExerBasketFlag(false);
    },
    leave: function () {
      setTimeout(() => {
        this.showdropwindow(0);
      }, 100);
      if(this.$refs.help != undefined){
        this.$refs.help.clearUnfold();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Home.vue